module.exports = __webpack_public_path__ + "static/media/riskOnePoint.1539ab6d.mp3";